<template />

<script>
import Repository from '@/repositories/RepositoryFactory'
import { initialAbility } from '@/libs/acl/config'
import requestDepositVMenu from '@/navigation/vertical/menu/requestDeposit'
import requestWithdrawVMenu from '@/navigation/vertical/menu/requestWithdraw'
import requestDepositHMenu from '@/navigation/horizontal/menu/requestDeposit'
import requestWithdrawHMenu from '@/navigation/horizontal/menu/requestWithdraw'

const ProfileRepository = Repository.get('profile')
const DepositRepository = Repository.get('depositRequest')

export default {
  created() {
    this.getProfile()
  },
  methods: {
    getProfile() {
      ProfileRepository.getProfile().then(response => {
        const data = response.data?.data
        data.ability.forEach(x => { x.subject = x.subject.toLowerCase() })
        this.$store.commit('profile/UPDATE_PROFILE', data)
        localStorage.setItem('userData', JSON.stringify(data))
        let newAbility = [...initialAbility]
        if (data.ability) {
          if (data.isReadonly) {
            data.ability.forEach(x => {
              x.action = 'read'
              return x
            })
          }
          newAbility = [...data.ability, ...initialAbility]
        }
        // if (data.actionBefore) {
        //   this.countDeposit()
        // } else {
        //   this.setBadge({
        //     deposit: 0,
        //     withdrawal: 0,
        //   })
        // }
        // Updating user ability in CASL plugin instance
        this.$ability.update([])
        this.$ability.update(newAbility)
      })
    },
    countDeposit() {
      DepositRepository.count().then(response => {
        const data = response.data?.data
        this.setBadge(data)
      })
    },
    setBadge(data) {
      if (requestDepositVMenu.length) {
        requestDepositVMenu[0].tag = data.deposit
      }
      if (requestWithdrawVMenu.length) {
        requestWithdrawVMenu[0].tag = data.withdrawal
      }
      if (requestDepositHMenu.length) {
        requestDepositHMenu[0].tag = data.deposit
      }
      if (requestWithdrawHMenu.length) {
        requestWithdrawHMenu[0].tag = data.withdrawal
      }
      this.$store.commit('profile/SET_BADGE', data)
    },
  },
}
</script>
